import { App } from '@gin-betting/core';
import { Map, OrderedSet, Record } from 'immutable';

import {
    GET_FEATURED_TOURNAMENTS_FAIL,
    GET_FEATURED_TOURNAMENTS_REQUEST,
    GET_FEATURED_TOURNAMENTS_SUCCESS,
} from './constants';
import type {
    Actions,
    FeaturedTournamentsStateShape,
    PromoState,
    PromoStateShape,
} from './types';
import { getTransformedFeaturedConfigs } from './utils';

const LOADED_ZONES = new Set<string>();

const FeaturedTournamentsRecord = Record<FeaturedTournamentsStateShape>(
    {
        configs: Map(),
        currentConfigs: OrderedSet([]),
        fetchStatus: App.FetchStatus.INITIAL,
    },
    'FeaturedTournamentsState'
);

const PromoStateRecord = Record<PromoStateShape>(
    {
        featuredTournaments: new FeaturedTournamentsRecord(),
    },
    'PromoState'
);

const initialState = new PromoStateRecord();

export default function reducer(
    state: PromoState = initialState,
    action: Actions
): PromoState {
    switch (action.type) {
        case GET_FEATURED_TOURNAMENTS_REQUEST: {
            const {
                args,
                variables: { zoneId },
            } = action.payload;

            if (args?.isPolling) {
                return state;
            }

            let nextFeaturedTournaments = state.featuredTournaments;

            // TODO: Refactor "fetchStatus", it should be used only within requested "zone" context
            if (!LOADED_ZONES.has(zoneId)) {
                nextFeaturedTournaments = nextFeaturedTournaments.set(
                    'fetchStatus',
                    App.FetchStatus.LOADING
                );

                LOADED_ZONES.add(zoneId);
            }

            return state.set('featuredTournaments', nextFeaturedTournaments);
        }

        case GET_FEATURED_TOURNAMENTS_SUCCESS: {
            const {
                data: { featuredZoneConfigs },
                allSports,
            } = action.payload;

            const { configs } = state.featuredTournaments;

            const nextConfigs = getTransformedFeaturedConfigs(
                featuredZoneConfigs,
                allSports
            );

            const newFeaturedTournaments = state.featuredTournaments
                .set('configs', configs.concat(nextConfigs))
                .set('currentConfigs', OrderedSet(nextConfigs.keys()))
                .set('fetchStatus', App.FetchStatus.LOADED);

            return state.set('featuredTournaments', newFeaturedTournaments);
        }

        case GET_FEATURED_TOURNAMENTS_FAIL: {
            const newFeaturedTournaments = state.featuredTournaments.set(
                'fetchStatus',
                App.FetchStatus.LOADED
            );

            return state.set('featuredTournaments', newFeaturedTournaments);
        }

        default:
            return state;
    }
}
